import { useEffect, useCallback } from 'react';

/**
 * Hook to listen for custom window events
 * Useful for cross-component communication via CustomEvent
 *
 * @param {string} eventName - The event name to listen for
 * @param {Function} handler - Callback function when event fires
 * @param {Array} deps - Optional dependencies array for handler
 */
export default function useWindowEvent(eventName, handler, deps = []) {
  const memoizedHandler = useCallback((event) => {
    handler(event.detail || event);
  }, deps);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener(eventName, memoizedHandler);

    return () => {
      window.removeEventListener(eventName, memoizedHandler);
    };
  }, [eventName, memoizedHandler]);
}
